export default "__VITE_ASSET__KBrDO2X2__"